import { render, staticRenderFns } from "./PuzzleNavigation.vue?vue&type=template&id=3ef58dd8&scoped=true&"
import script from "./PuzzleNavigation.vue?vue&type=script&lang=js&"
export * from "./PuzzleNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleNavigation.vue?vue&type=style&index=0&id=3ef58dd8&lang=scss&scoped=true&"
import style1 from "./PuzzleNavigation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef58dd8",
  null
  
)

export default component.exports